import {Component, Input, OnInit} from '@angular/core';
import {AdminService} from "../../../../../core/services/AdminService";
import {NavController} from "@ionic/angular";
import {BusinessService} from "../../../../../core/services/BusinessService";

@Component({
    selector: 'app-minibox',
    templateUrl: './minibox.component.html',
    styleUrls: ['./minibox.component.scss'],
})
export class MiniboxComponent implements OnInit {
    @Input()
    exTableData;
    @Input()
    sectionName;
    @Input()
    prefix;
    @Input()
    tableParams;
    @Input()
    model;

    //for display index
    @Input()
    rowIndex;

    @Input()
    hideHeader = false;

    @Input()
    showOpen = false;

    //extra data and genric models buttons
    @Input()
    boxSmall = true;

    @Input()
    showEditFields = false;
    editFields = [];

    @Input()
    specificBoxFields;

    //need to open model view on click?
    @Input()
    clickEvent: boolean = true;

    tableData;
    modelType;

    constructor(public adminService: AdminService, public navCtrl: NavController, public businessService: BusinessService) {
    }

    ngOnInit() {
        this.tableData = this.exTableData[this.sectionName + 'Data'];
        this.modelType = this.exTableData[this.sectionName + 'Ref'];

        for (let i in this.modelType) {

            if (this.modelType[i]['showInBox']) {
                //no hides defined or not in hidden fields
                if (this.editFields.indexOf(this.modelType[i]) == -1) {
                    this.editFields.push(this.modelType[i]);
                }
            }

            // if (this.editFields.length > 5) break;
        }

        if (this.editFields.length < 5) {
            for (let i in this.modelType) {
                if (this.modelType[i]['showTable']) {
                    if (this.editFields.indexOf(this.modelType[i]) == -1) {
                        this.editFields.push(this.modelType[i]);
                    }
                }
            }
        }
    }

    //, this.model['id']['value']
    onClick(event) {
        if (this.clickEvent) {
            // if (this.tableData['fullWindow']) {
            // this.adminService.openCustomModel(this.navCtrl, this.sectionName, null, null, null, this.model);
            // } else {
            this.adminService.popupEditBox(event, this.sectionName, this.exTableData, 'dadad',
                this.model, 'modelTableEdit', this.exTableData[this.sectionName + 'Data']['smallerPopup'] ? false : true, null, null);
            //     event.stopPropagation();
            // }
        }
    }
}
